export const BARSCHARTS = [
    {dataKey:'nHorasControl', fill:'#70AF52'},
    {dataKey:'nHorasUtilidad',fill:'#E09A05'},
    {dataKey:'nHorasTotal',fill:'#855AFF'}
]